import dClient from "../../Components/api/reduxLoaderApi";
import {setAttributes} from "./slice"
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";


export const getAttributes = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `attribute`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(setAttributes(res.data.attributes));
    // return callback && callback(res.data.product.attributes);
};

export const postProductType = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `product-type`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};